const PREFIX = 'LASF';

const LASF_PROJECTION = 2112;
const GEOTIFF_PROJECTION = 34735;

const LITTLE_ENDIAN = true;

class LasFormat {
	constructor(format, coordinateSytem) {
		this.format = format;
		this.coordinateSystem = coordinateSytem;
	}
	
	getFormat() {
		return this.format;
	}
	
	hasCoordinateSystem() {
		return this.coordinateSystem;
	}
	
}

const hasCoordinateSystem = async (reader) => {
	let buffer = await reader.read(94, 100);
	let dataView = new DataView(buffer);
	
	const headerSize = dataView.getUint16(0, LITTLE_ENDIAN);	
	const dataOffset = dataView.getUint32(2, LITTLE_ENDIAN);   
	
	buffer = await reader.read(headerSize, dataOffset);
	dataView = new DataView(buffer);
	
	let bufferOffset = 0;
                
    while(bufferOffset < buffer.byteLength) {
    	// read variable records                                
        const recordId = dataView.getUint16(18 + bufferOffset, LITTLE_ENDIAN);
        const recordLengthAfterHeader = dataView.getUint16(20 + bufferOffset, LITTLE_ENDIAN);
        
        if( recordId == GEOTIFF_PROJECTION || recordId == LASF_PROJECTION ) {                
        	return true;
        } else {
        	console.log("Found variable record with id ", recordId);        
        }
            
        bufferOffset = bufferOffset + 54 + recordLengthAfterHeader;
    }         
	
	return false;
}

const las = async (reader) => {
	const buffer = await reader.read(0, 4);
	let text = new TextDecoder().decode( buffer );

	let dataFormat = -1;
	let coordinateSystem = false;
	
	if( text === PREFIX ) {	
		const arrayBuffer = await reader.read(104, 106);		
		const dataView = new DataView(arrayBuffer);
		
		// point format is stored at offset 104;                     
		dataFormat = dataView.getUint8(0);
		
		coordinateSystem = await hasCoordinateSystem(reader);
	}
	
	return new LasFormat(dataFormat, coordinateSystem);
}

export {
	las
}